import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { roleUrlSegment } from '@core/constants';

/**
 * Servicio de redirección post-login según el rol del usuario.
 * Mapea el slug del rol al segmento de URL correspondiente:
 * `administrator` → `/configuration`, demás roles → `/{role}`.
 */
@Injectable({ providedIn: 'root' })
export class RedirectGuardService {
  private readonly _router = inject(Router);

  /**
   * Lee el rol almacenado en `localStorage` y navega al dashboard correspondiente.
   * Si no hay rol almacenado, no realiza ninguna navegación.
   */
  redirectService() {
    const role = localStorage.getItem('role');
    if (role) {
      const lowerRole = role.toLocaleLowerCase();
      // 'entidad_financiera' es el nombre real del rol, pero su segmento de URL es
      // 'financial-entity' (no coinciden, a diferencia de 'executor'/'implementer'/'auditor').
      const urlRole = roleUrlSegment(lowerRole);
      void this._router.navigate([`${urlRole}`]);
    }
  }
}
